export default "__VITE_ASSET__CGA1R1kR__"